import React, { useEffect } from 'react'
import { PaginaNode } from '@gql/graphql'
import useLocale from '@hooks/useLocale'
import { PlaceholderReact } from '@components/molecules'
import { GenericHero, Page, Prefooter } from 'components/organisms'
import styles from './ContattiTemplate.module.sass'

interface Props {
  pagina?: PaginaNode
}

const ContattiTemplate = (props: Props) => {
  const { pagina = undefined } = props

  const locale = useLocale()
  const defaultContent1 = pagina?.pagebuilders?.find((x) => x.key === 'main') ?? null

  useEffect(() => {
    const loadScript = (src: string, onLoad?: () => void) => {
      const script = document.createElement('script')
      script.src = src
      script.async = true
      if (onLoad) script.onload = onLoad
      document.head.appendChild(script)
    }
    loadScript(
      `https://mailing.emilgroup.it/w/widget-${
        locale.isAmerica ? 'emilamerica' : 'emilgroup'
      }-src/widget-contact-${locale.lang}.js`
    )
  }, [])

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <GenericHero pagina={pagina} />
        <div className={`${styles.form} ext-forms`} id="formContatti"></div>
        <div className={styles.placeholderContent}>
          <PlaceholderReact
            contentTypeId={pagina.model}
            objectId={pagina.pk}
            pkey={'main'}
            serverSideContent={defaultContent1}
          />
        </div>
        <Prefooter skipContatti />
      </main>
    </Page>
  )
}

export default ContattiTemplate
